import React from "react";
import { Box, Paper, Typography, Container } from "@mui/material";

const Support = () => {
  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "transparent",
          padding: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 4,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(10px)",
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
          >
            Support
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "1.2rem", textAlign: "center", color: "#555" }}
          >
            Thank you for visiting the Support section. Your feedback is always
            appreciated, and this platform is here to help you with any issues
            or questions you may have.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            If you’ve opted for any consultations, you will be able to see the
            schedule here. Additionally, you can use the chat function to
            respond or communicate with your consultant.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            Soon, you will also be able to raise and track support tickets right
            here. This feature is being designed to offer you seamless
            assistance with any concerns regarding the platform.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            Just like the rest of the platform, this support system is part of a
            bigger vision. Every aspect of the frontend and backend has been
            built from scratch as part of my personal endeavor to create
            something meaningful.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Support;
